import { render, staticRenderFns } from "./TelaCheia.vue?vue&type=template&id=bf20a7ea&scoped=true"
import script from "./TelaCheia.vue?vue&type=script&lang=js"
export * from "./TelaCheia.vue?vue&type=script&lang=js"
import style0 from "./TelaCheia.vue?vue&type=style&index=0&id=bf20a7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf20a7ea",
  null
  
)

export default component.exports